import React, { useState, useEffect } from "react";
import SpinningLoader from "@src/components/common/SpinningLoader";
import ProductListRow from "@src/components/widgets/ProductListRow";
import * as ProductApi from "@src/api/ProductApi";
import { useToast } from "@swordsweeper/ssi-ui-component-library";

interface Product {
  id: string;
  [key: string]: any;
}

interface ProductRecommendation {
  label: string;
  products: Product[];
}

interface ProductRecommendationsProps {
  type: string;
  count?: number;
  renderSectionHeader?: () => React.JSX.Element;
}

export default function ProductRecommendations({
  type,
  count,
  renderSectionHeader,
}: ProductRecommendationsProps) {
  const { showToast } = useToast();
  const [isLoadingProductRecommendations, setIsLoadingProductRecommendations] =
    useState<boolean>(false);
  const [productRecommendations, setProductRecommendations] = useState<
    ProductRecommendation[] | null
  >(null);

  useEffect(() => {
    if (type) {
      handleLoadProductRecommendations();
    }
  }, [type, count]);

  const handleLoadProductRecommendations = async (): Promise<void> => {
    setIsLoadingProductRecommendations(true);
    try {
      const response = await ProductApi.getProductRecommendations(type, {
        pageSize: count,
      });
      setProductRecommendations(response.body.results);
    } catch (e) {
      console.error(e);
      showToast({
        message: "Error loading product recommendations",
        variant: "error",
      });
    } finally {
      setIsLoadingProductRecommendations(false);
    }
  };

  return (
    <div className="flex-column spaced-content-v-lg">
      {isLoadingProductRecommendations && <SpinningLoader />}

      {!!productRecommendations && (
        <>
          {!!renderSectionHeader && renderSectionHeader()}
          <ProductListRow
            products={productRecommendations}
            tileClassName="height-initial-important"
            imageSizePx={200}
            idContext="product-recommendations-product-tile"
            data-testid="product-recommendations-product-list-row"
          />
        </>
      )}
    </div>
  );
}
